// extracted by mini-css-extract-plugin
export default {"favoriteCompact":"favoriteCompact__NTY2Z","heartImg":"heartImg__ODU5M"};